import Util from '../util';

const url = '/api/colorcalc/user';
const Api = {
  getAsync() {
    return fetch(`${Util.apiSegment}${url}`).then(response => response.json());
  }
};
export default Api;
